import React from 'react';
import classnames from 'classnames';
import './ActionTypeIconWrapper.styl';

export default class ActionTypeIconWrapper extends React.PureComponent {
  render() {
    const {enabled, children} = this.props;
    return <div className={classnames('action-type-icon-wrapper', {enabled})}>{children}</div>;
  }
}
